import { createSelector } from '@ngrx/store';

import { OperatorSettingsLoadState } from '../../../models/operator-settings.model';
import { operatorSettingsFeature } from '../operator-settings.feature';

const { selectOperatorSettings } = operatorSettingsFeature;

export const selectSettings = createSelector(
  selectOperatorSettings,
  (state) => state.settings,
);

export const selectLoadState = createSelector(
  selectOperatorSettings,
  (state) => state.loadState,
);

export const selectError = createSelector(
  selectOperatorSettings,
  (state) => state.error,
);

export const selectIsLoading = createSelector(
  selectLoadState,
  (loadState: OperatorSettingsLoadState) => loadState === 'loading',
);

export const selectIsLoaded = createSelector(
  selectLoadState,
  (loadState: OperatorSettingsLoadState) => loadState === 'loaded',
);

export const selectHasError = createSelector(
  selectLoadState,
  (loadState: OperatorSettingsLoadState) => loadState === 'error',
);
